export default {
  projectName: 'testscope.id',
  projectDomain: 'testscope',
  projectDomainTld: 'id',
  // Empty means same origin, e.g. behind the local proxy on :5000
  backendUrl: process.env.REACT_APP_BACKEND_URL || '',
};
